import React, {useEffect, useState} from 'react';
import shortid from 'shortid';
import FRIEND from "../images/button_icon_add_friend.svg";
import LOGO from "../images/logo.svg";
import { useHistory } from 'react-router-dom';

export default function Top() {

	const history = useHistory();
	const [shareLink, setShareLink] = useState(null);
	useEffect(()=>{
		setShareLink(generateShareLink());
	},[])

	async function clickShare() {
		if(window.navigator.share){
			await window.navigator.share({
				title: 'CALLRUN',
				text: '',
				url: document.URL+"call"+shareLink,
			}).then(()=>{
				console.log('Successful share');
				history.push({
					pathname: '/call',
					search: shareLink
				});
			}).catch((error)=>{
				console.log('Error sharing', error);
				window.alert("共有したリンクから通話に参加してください．");
			})
		}else{
			window.alert("お使いいただけない端末です．GPSが搭載された携帯端末をお使いください．");
		}
	}
	return (
		<div className="main">
			<img className="logo" src={LOGO} alt="走ると話せるトークアプリCALLRUN"/>
			<button className="button" onClick={clickShare}><img src={FRIEND}></img>友達を誘ってみる</button>
			<br></br>
		</div>
	)
}

// TODO : 後々ランダムなIDを生成するように変更
function generateShareLink() {
	return "?roomid=" + shortid.generate();
}
